import React, { useState } from 'react';
import { Formik } from 'formik';
import { Form, Input } from 'formik-antd';
import { Modal, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import Row from '~/components/Row';
import FormControl from '~/components/Form/FormControl';
import { ModalFooter } from '~/components/Modal';

const initialValues = {
  website: '',
  faxNumber: '',
  other: '',
};

export default function OtherContactForm({ visible, onClose, onChange, contact }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const getInitialValues = () => {
    if (!contact) return initialValues;
    
    return {
      website: contact.website || '',
      faxNumber: contact.faxNumber || '',
      other: contact.other || '',
    };
  };

  const handleSave = async (values) => {
    setLoading(true);
    try {
      const updatedContact = contact 
        ? { ...contact, ...values }
        : values;
      
      onChange(updatedContact);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Formik initialValues={getInitialValues()} enableReinitialize onSubmit={handleSave}>
      {({ isSubmitting, submitForm, resetForm }) => (
        <Modal
          title={t('screens:contact.btnEdit')}
          onCancel={onClose}
          afterClose={resetForm}
          open={visible}
          loading={loading || isSubmitting}
          footer={
            <ModalFooter onOk={submitForm} loading={loading || isSubmitting} onCancel={onClose} cancelColor="default" />
          }
        >
          <Spin spinning={loading || isSubmitting}>
            <Form>
              <Row>
                <FormControl cols={{ xs: 24 }} field="website" label={t("screens:accounts.data.website")}>
                  <Input name="website" autoComplete="off" />
                </FormControl>
                <FormControl cols={{ xs: 24 }} field="faxNumber" label={t("screens:accounts.data.faxNumber")}>
                  <Input name="faxNumber" autoComplete="off" />
                </FormControl>
                <FormControl cols={{ xs: 24 }} field="other" label={t("screens:accounts.data.other")}>
                  <Input name="other" autoComplete="off" />
                </FormControl>
              </Row>
            </Form>
          </Spin>
        </Modal>
      )}
    </Formik>
  );
}